import { AssignOrUnAssignEnum } from '@app/user/shared/models/teammate';

export const GROUPS_DESCRIPTION = 'Below is a list of the users groups you have created for your organization. ' +
  'Assign Applications and Subsystems to groups to determine their permissions.';
export const GROUP_PAGE_TITLE = 'Groups';
export const GROUP_MAIN_TITLE = 'Coralogix User Groups';
export const MAX_SCOPE_ITEMS = 10;
export const ASSIGN = AssignOrUnAssignEnum.assign;
export const UNASSIGN = AssignOrUnAssignEnum.unassign;
